export default __webpack_public_path__ + "static/media/legal-cookie.e9dd20f6.png";